import React from 'react';
import { Button } from '@shopify/polaris';
import { useAuth } from '@/hooks/auth';

const SignOutButton: React.FC = () => {
  const [, { signOut }] = useAuth();

  const handleSignOut = async () => {
    await signOut();
    // temporary fix
    location.reload();
  };

  return (
    <Button onClick={handleSignOut} variant="primary" fullWidth>
      Sign Out
    </Button>
  );
};

export default SignOutButton;
